<script>
export default {
  name: 'TimerWarning',
  props: {
    size: {
      type: [Number, String],
      default: 40,
    },
    color: {
      type: String,
      default: '#BA9309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" :fill="color" fill-opacity="0.2" />
    <path
      d="M25.3895 23.67L21.3495 20H18.6395L14.5995 23.67C13.4695 24.69 13.0995 26.26 13.6495 27.68C14.1995 29.09 15.5395 30 17.0495 30H22.9395C24.4595 30 25.7895 29.09 26.3395 27.68C26.8895 26.26 26.5195 24.69 25.3895 23.67ZM21.8195 26.14H18.1795C17.7995 26.14 17.4995 25.83 17.4995 25.46C17.4995 25.09 17.8095 24.78 18.1795 24.78H21.8195C22.1995 24.78 22.4995 25.09 22.4995 25.46C22.4995 25.83 22.1895 26.14 21.8195 26.14Z"
      :fill="color"
    />
    <path
      d="M26.3506 12.32C25.8006 10.91 24.4606 10 22.9506 10H17.0506C15.5406 10 14.2006 10.91 13.6506 12.32C13.1106 13.74 13.4806 15.31 14.6106 16.33L18.6506 20H21.3606L25.4006 16.33C26.5206 15.31 26.8906 13.74 26.3506 12.32ZM21.8206 15.23H18.1806C17.8006 15.23 17.5006 14.92 17.5006 14.55C17.5006 14.18 17.8106 13.87 18.1806 13.87H21.8206C22.2006 13.87 22.5006 14.18 22.5006 14.55C22.5006 14.92 22.1906 15.23 21.8206 15.23Z"
      :fill="color"
    />
  </svg>
</template>
